export default __webpack_public_path__ + "static/media/darkmode-off.d672c5b4.svg";